import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { makeStyles } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { getTextInBold } from '~/modules/common/util';
import { DEFAULT_TARGET_UTILIZATION } from '../../../hooks/useTargetUtilizationSettings';

const useStyles = makeStyles(theme => ({
  bulletList: {
    margin: theme.spacing(0.5, 0, 0, 0),
    paddingLeft: theme.spacing(2.5)
  }
}));

const formatValues = getTextInBold();

const TargetUtilizationAlert = ({ value }) => {
  const classes = useStyles();
  const isDefault = value === DEFAULT_TARGET_UTILIZATION;

  return (
    <Alert severity={isDefault ? 'info' : 'warning'}>
      <FormattedMessage
        id={
          isDefault
            ? 'resourceManagementDashboard.targetUtilizationSettings.infoMessage'
            : 'resourceManagementDashboard.targetUtilizationSettings.warningMessage'
        }
      />
      <ul className={classes.bulletList}>
        <li>
          <FormattedMessage
            id="resourceManagementDashboard.targetUtilizationSettings.benchDescription"
            values={formatValues}
          />
        </li>
        <li>
          <FormattedMessage
            id="resourceManagementDashboard.targetUtilizationSettings.overAllocationDescription"
            values={formatValues}
          />
        </li>
      </ul>
    </Alert>
  );
};

TargetUtilizationAlert.propTypes = {
  value: PropTypes.number.isRequired
};

export default TargetUtilizationAlert;
